import type { RedemptionResult } from '../../declarations/ah-api';
import type { RedeemAction } from '../actions/redeem-actions';

import * as types from '../actions/action-types';

export default function redeemReducer(
  state: RedemptionResult = {} as RedemptionResult,
  action: RedeemAction
): RedemptionResult {
  switch (action.type) {
    case types.REEDEMED_SUCCESS:
      return action.redemptionResult;
    default:
      return state;
  }
}
